
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.outline-breadcrumbs {
  background-color: var(--idblab-green-main);
  font-size: var(--fs-sm);
  line-height: var(--lh-sm);
}

.outline-breadcrumbs outline-container {
  display: flex;
}

.breadcrumb {
  display: flex;
  align-content: center;
  color: var(--neutral-white);
}

.mobile-icon {
  display: block;
}

@media (min-width: 768px) {

  .mobile-icon {
    display: none;
  }
}

span:not(.previous) {
  display: none;
}

@media (min-width: 768px) {

  span:not(.previous) {
    display: inline;
  }
}

@media (min-width: 640px){
  .breadcrumb span{
    flex-basis:max-content;
  }
}

.separator {
  display: none;
  padding-top: 1px;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
}

@media (min-width: 768px) {

  .separator {
    display: inline;
  }
}
`;